import type { Flow } from '../../../modules/Auth0/types';
import { captchaEvent } from '../../../modules/metrics';

import { logError } from './utils';

export const resetCaptchaToken = async (
  flow: Flow,
  googleCaptchaSiteKey: string,
  attempt: number = 1,
): Promise<string | undefined> =>
  new Promise((resolve) => {
    try {
      const { grecaptcha: { enterprise: enterpriseRecaptcha } = {} } = window;
      if (!enterpriseRecaptcha) {
        captchaEvent('recaptcha_library_not_loaded');
        return resolve(undefined);
      }
      enterpriseRecaptcha.ready(() => {
        try {
          enterpriseRecaptcha.reset();
          captchaEvent('recaptcha_reset');
          return resolve('ok');
        } catch (err) {
          logError(
            new Error('Error resetting recaptcha'),
            'recaptcha_loaded_but_reset_failed',
          );
          return attempt === 1
            ? resolve(
                resetCaptchaToken(flow, googleCaptchaSiteKey, attempt + 1),
              )
            : resolve(undefined);
        }
      });
    } catch (err) {
      logError(
        new Error('Error resetting recaptcha'),
        'error_resetting_recaptcha',
      ); // first argument with type Error
      return resolve(undefined);
    }
  });
